import { Directive, Input } from '@angular/core';

@Directive({
  selector: '[max-height]',
  standalone: true,
  host: {
    '[style.max-height]': 'maxHeight',
  }
})
export class MaxHeightDirective {

  @Input({ alias: 'max-height' }) maxHeight: string;
}
